import React from 'react';
import RatesType from '@app/model/market_state/RatesType';
import CompanyHotelDashboardFilter from '@app/model/company_hotel/settings/CompanyHotelDashboardFilter';
import MarketStateFilterInput from '@app/model/market_state/input/MarketStateFilterInput';
import {
	useMarketStateFilterInputTools,
} from '@app/site/secured/rateshopper/rates/provider/useMarketStateFilterInputTools';
import MenuButtonFilter from '@app/component/menu/MenuButtonFilter';
import { FilterConfig } from '@app/site/secured/rateshopper/rates/provider/MarketStateFilterInputProvider';

type DashboardSelectRatesTypeFilterProps = {
	filter: MarketStateFilterInput,
	onFilter: (filter: MarketStateFilterInput) => void,
	overrideDefaultConfiguration?: FilterConfig,
	hideAnySelection?: boolean
}

const DashboardSelectRatesTypeFilter = React.memo(
	function DashboardSelectRatesTypeFilter({ filter, onFilter, hideAnySelection, overrideDefaultConfiguration }: DashboardSelectRatesTypeFilterProps) {
		const { isDashboardFilterEnabled } = useMarketStateFilterInputTools();
		const providerSupportsFilter = !!overrideDefaultConfiguration ? overrideDefaultConfiguration.enabled : isDashboardFilterEnabled(CompanyHotelDashboardFilter.RATE);

		const menuItems = [];
		if(!hideAnySelection) {
			menuItems.push({ name: 'Any Rate', value: undefined });
		}

		menuItems.push(
			{ name: 'Public Rates', description: 'Without membership', value: RatesType.PUBLIC },
			{ name: 'Member Rates', description: 'With membership', value: RatesType.MEMBER },
		);


		const onSelect = (value: RatesType) => {
			onFilter({ ...filter, ratesType: value });
		};

		return <MenuButtonFilter menuItems={menuItems}
														 selectedValue={filter.ratesType}
														 onSelect={onSelect}
														 menuDescription="Please select if you wish to include Member Rates in your results."
														 disabled={!providerSupportsFilter} />;

	},
);

export default DashboardSelectRatesTypeFilter;